import DefaultHomecard from './DefaultHomecard';

export { HOMECARD_IMAGE_RATIOS } from './DefaultHomecard';

export default DefaultHomecard;
